/*eslint-disable*/
import axios from 'axios';
import {baseApiUrl} from "../../../config.js";

const state = {
  mapWebScene: null,
  mapView: null,
  initialSensors: [],
  commentReplies: [],
  currentSensorId: null,
  currentComment: null,
  currentReplies: [],
  userName: null,
  replyAttachments: []
}

function initialState() {
  return {
    mapWebScene: null,
    mapView: null,
    initialSensors: [],
    commentReplies: [],
    currentSensorId: null,
    currentComment: null,
    currentReplies: [],
    userName: null,
    replyAttachments: []
  }
}
const mutations = {
  saveMapWebScene(state, data) {
    state.mapWebScene = data
  },
  saveMapView(state, data) {
    state.mapView = data
  },
  saveUserName(state, data) {
    state.userName = data
  },
  insertInitialSensors(state, payload) {
    state.initialSensors.push(payload)
  },
  resetInitialSensors(state) {
    state.initialSensors = []
  },
  resetCommentReplies(state) {
    state.commentReplies = []
  },
  insertCommentReplies(state, payload) {
    state.commentReplies.push(payload)
  },
  setCurrentCommentId(state, payload) {
    state.currentSensorId = payload
  },
  setCurrentComment(state, payload) {
    state.currentComment = payload
  },
  setCurrentReplies(state, payload) {
    payload.replies.forEach(item=>{
      state.currentReplies.push(item)
    })
  },
  clearCurrentReplies(state) {
    state.currentReplies = []
  },
  addNewReply(state, payload) {
    var objectId = payload.objectId
    var currentReplies = state.commentReplies.filter(obj=>obj.objectId == objectId)
    if (currentReplies.length) {
      currentReplies[0].replies.push(payload.reply)
    }
    else {
      var commentReply = {
        decision: payload.decision,
        objectId: objectId,
        replies: [payload.reply]
      }
      console.log(commentReply);
      state.commentReplies.push(commentReply)
    }
  },
  finalizeComment(state, payload) {
    var currentComment = state.initialSensors.filter(obj=>obj.objectId == payload.objectId)
    currentComment[0].approvalStatus = payload.decision?"Approved":currentComment.approvalStatus
    console.log(currentComment);
  },
  clearAttachments(state) {
    state.replyAttachments = []
  },
  addAttachment(state, payload) {
    state.replyAttachments.push(payload)
  },
  removeAttachment(state, index) {
    state.replyAttachments.splice(index,1)
  }
}

const actions = {
  async fetchCommentReplies ({commit, dispatch}, payload) {
    return new Promise(function(resolve, reject) {
      let url = baseApiUrl + "fetchReplies"
      let data    = {
        commentIds: payload.objectIds
      }
      let config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        commit("resetCommentReplies")
        result.data.forEach((item,index) => {
          commit('insertCommentReplies', item);
        })
        resolve();
      }).catch(error=>{
        reject(error);
      })
    })
  },
  setCurrentCommentDetails({state, commit}, payload) {
    commit("setCurrentCommentId", payload)
    var currentComment = state.initialSensors.filter(obj=>obj.objectId == payload)
    if (currentComment.length) {
      commit("setCurrentComment", currentComment)
    }
    var currentReplies = state.commentReplies.filter(obj=>obj.objectId == payload)
    commit("clearCurrentReplies")
    if (currentReplies.length) {
      commit("setCurrentReplies", currentReplies[0])
    }
    console.log("Current Comment: ");
    console.log(state.currentComment);
    console.log("Current Replies: ");
    console.log(state.currentReplies);
  }
}

const getters = {}



export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
